import React, { ReactElement } from "react";
import { Flex, Box, Heading, Text } from "rebass";

interface IProps {
  author?: string | undefined;
  quote?: ReactElement | null;
  img?: string | undefined;
  learning?: string | undefined;
}

const ChatBubble = (props: IProps) => {
  return (
    <Box width={[1/1]} p={[3,4,5]} variant="containerBigTitle">
      <Flex flexWrap="wrap-reverse" justifyContent={["center","start"]} alignItems={"flex-start"}>
        {props.img !== undefined && (
          <Box
            width={[1 / 1, 1/2]}
            maxWidth={["182px"]}
            mr={[2, 3]}
            variant="wrapperImg"
          >
            <img src={props.img} alt="Screen user testing" />
          </Box>
        )}
        <Box
          width={[1 / 1, 1/2]}
          p={[3, 4]}
          variant="chatBubble"
          my={[3,0,0]}
        >
          <Box width={[1/1]}>{props.quote}</Box>
          <Text as="p" variant="caption" pt={[1,2,2]} pb={[0, 0, 0]}>
            {props.author}
          </Text>
        </Box>
      </Flex>
      {props.learning !== undefined && (
        <Box>
          <Heading as="h3" variant="catHeading">
            Learning
          </Heading>
          <Text as="p" variant="paragraphXL" mb={[2,3]}>
            {props.learning}
          </Text>
          </Box>
      )}
    </Box>
  );
};

export default ChatBubble;
